import React from 'react';

/**
 * Charts the agent rendered for one answer. The stream's final payload carries
 * them as [{ id, title, data: <PNG data-URI> }]; `type`/`status`/`description`
 * are older optional fields and only render when present.
 */
const PlotDisplay = ({ plots }) => {
  if (!plots || plots.length === 0) {
    return null;
  }

  return (
    <div className="mt-4 space-y-4">
      <h4 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
        📊 Generated Visualizations
      </h4>
      {plots.map((plot, index) => (
        <div key={plot.id ?? index} className="border rounded-lg p-4 bg-gray-50 dark:bg-gray-800">
          <div className="flex items-center justify-between mb-2">
            <h5 className="font-medium text-gray-700 dark:text-gray-300">
              {plot.title || plot.description || `Plot ${index + 1}`}
            </h5>
            {plot.type && (
              <span className="text-xs px-2 py-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded">
                {plot.type}
              </span>
            )}
          </div>

          {plot.data ? (
            <div className="mt-3">
              <img
                src={plot.data}
                alt={plot.title || plot.description || `Generated plot ${index + 1}`}
                className="max-w-full h-auto border rounded"
                style={{ maxHeight: '400px' }}
              />
            </div>
          ) : (
            <div className="mt-3 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded">
              <p className="text-sm text-yellow-800 dark:text-yellow-200">
                ⚠️ Plot was generated but data is not available for display. 
                This is a placeholder visualization.
              </p>
            </div>
          )}

          {plot.status && (
            <div className="mt-2 text-xs text-gray-500 dark:text-gray-400">
              Status: {plot.status}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PlotDisplay;
